export default "__VITE_ASSET__9VZqGqq5__"